var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTfaiLogoW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 35",
    style: {
      enableBackground: "new 0 0 55 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,7.4c-8.3,1.2-16.8,1.8-25.3,1.8h0v3.5h0c8,0,16-0.6,23.9-1.6v19c0,0.6-0.5,1-1,1H26.6v3.4h24 c1.9,0,3.4-1.5,3.4-3.4v-24L52,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,0.5v4c5.5,3.2,10.9,4.4,12.8,4.7V5.8C24.3,5.3,18.9,3.8,13.8,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,34.5h3.4v-22c1.7-0.5,3.7-1.2,5.9-2.2v24.1h3.4V4.6C8.7,7.9,3.4,9.3,1,9.8V34.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfaiLogoW);
export default __webpack_public_path__ + "static/media/TFAI-logo-w.d9c83c259fdeb05a630df4b5ddd0d807.svg";
export { ForwardRef as ReactComponent };